"use client";

import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TrendingUp } from "lucide-react";
import AnalyticsSummary from "./summary/analytics-summary";
import AnalyticsTable from "./table/analytics-table";
import AnalyticsCharts from "./charts/analytics-charts";
import { useTranslation } from "react-i18next";

interface AnalyticsDashboardProps {
  previewId: string;
  className?: string;
}

export default function AnalyticsDashboard({
  previewId,
  className,
}: AnalyticsDashboardProps) {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
  };
  const { t } = useTranslation("analytics");
  return (
    <div className={`space-y-6 ${className}`}>
      <div className="space-y-1">
        <h2 className="text-2xl font-bold tracking-tight">
          {t("analytics:analyticsDashboard.title")}
        </h2>
        <p className="text-muted-foreground">
          {t("analytics:analyticsDashboard.description")}
        </p>
      </div>

      <Tabs defaultValue="overview" className="space-y-6">
        <TabsList className="grid w-full grid-cols-2 lg:w-auto lg:grid-cols-2">
          <TabsTrigger value="overview" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            <span className="hidden sm:inline">
              {t("analytics:analyticsDashboard.tabs.overview")}
            </span>
          </TabsTrigger>
          <TabsTrigger value="sessions" className="flex items-center gap-2">
            <Table className="h-4 w-4" />
            <span className="hidden sm:inline">
              {t("analytics:analyticsDashboard.tabs.sessions")}
            </span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-6">
          <AnalyticsSummary
            key={`summary-${refreshKey}`}
            previewId={previewId}
            onRefresh={handleRefresh}
          />
          <AnalyticsCharts
            key={`charts-${refreshKey}`}
            previewId={previewId}
            onRefresh={handleRefresh}
          />
        </TabsContent>

        <TabsContent value="sessions" className="space-y-6">
          <AnalyticsTable key={`table-${refreshKey}`} previewId={previewId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
